// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"50019204","219":"d8862711","252":"882436a1","371":"e1d967f8","453":"5d9d47fd"}[chunkId] + ".chunk.js";
};